import { requests } from "./requests";

export const queries = {
  getBranding: () => ({
    queryKey: [requests.key, "branding"],
    queryFn: () => requests.getBranding(),
  }),
  getStylesheet: () => ({
    queryKey: [requests.key, "stylesheet"],
    queryFn: () => requests.getStylesheet(),
  }),
};
